import {
  GET_ANNOUNCEMENTS_ERROR,
  GET_ANNOUNCEMENTS_PENDING,
  GET_ANNOUNCEMENTS_SUCCESS,
  GET_MY_ACTIVITY_ERROR,
  GET_MY_ACTIVITY_PENDING,
  GET_MY_ACTIVITY_SUCCESS,
  SET_ANNOUNCEMENTS,
  SET_MY_ACTIVITY,
} from './constants';

const INIT_STATE = {
  announcements: [],
  isGetAnnouncementPending: false,
  myActivity: {},
  isGetMyActivityPending: false,
};

export default (localState = INIT_STATE, action) => {
  switch (action.type) {
    case GET_ANNOUNCEMENTS_PENDING: {
      return {
        ...localState,
        isGetAnnouncementPending: true,
      };
    }
    case GET_ANNOUNCEMENTS_SUCCESS: {
      return {
        ...localState,
        isGetAnnouncementPending: false,
      };
    }
    case GET_ANNOUNCEMENTS_ERROR: {
      return {
        ...localState,
        isGetAnnouncementPending: false,
      };
    }
    case SET_ANNOUNCEMENTS: {
      return {
        ...localState,
        announcements: action.payload,
      };
    }
    case GET_MY_ACTIVITY_PENDING: {
      return {
        ...localState,
        isGetMyActivityPending: true,
      };
    }
    case GET_MY_ACTIVITY_SUCCESS: {
      return {
        ...localState,
        isGetMyActivityPending: false,
      };
    }
    case GET_MY_ACTIVITY_ERROR: {
      return {
        ...localState,
        isGetMyActivityPending: false,
      };
    }
    case SET_MY_ACTIVITY: {
      return {
        ...localState,
        myActivity: action.payload[0],
      };
    }
    default:
      return { ...localState };
  }
};
